module.exports = __webpack_public_path__ + "img/three_4.b8cbdd4a.png";